module.exports = __webpack_public_path__ + "static/media/video.227f7f72.svg";